import { genericOAuthClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { initAuthClient } from '@package/auth/client'

import { env } from '~/env'

export const authClient = createAuthClient(
  initAuthClient({
    baseUrl: env.NEXT_PUBLIC_MARKETING_URL,
    extraPlugins: [genericOAuthClient()],
  }),
)
